import React from "react";
import { useSiteContext } from "../../../../../context/SiteContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";

const HorizontalTemplateOneOneSix = ({
  logoImage = "/yourLogo.svg",
  logoImagePreview = null,

  titleText = "MAKE YOUR NEXT MOVE",
  titleFont = "Helvetica",
  titleFontSize = "36",
  titleColor = "#E91E63",
  titleTextAlign = "left",
  titleIsBold = true,
  titleIsItalic = false,
  titleIsUnderline = false,
  titleUppercase = true,

  subtitleText = "A quick action to keep momentum.",
  subtitleFont = "Helvetica",
  subtitleFontSize = "16",
  subtitleColor = "#FFFFFF",
  subtitleTextAlign = "left",
  subtitleIsBold = false,
  subtitleIsItalic = false,
  subtitleIsUnderline = false,

  backgroundType = "color",
  backgroundColor = "#1A2B8C",
  backgroundImage = null,

  buttonLabel = "I want it!",
  buttonFont = "Helvetica",
  buttonIsBold = false,
  buttonIsItalic = false,
  buttonIsUnderline = false,
  buttonLink = "",
  buttonFontSize = "16",
  buttonFontColor = "#FFFFFF",
  buttonBackgroundColor = "#E91E63",

  backgroundImagePreview,

  inmeeting = false,
  position = null,
  preview = false,
  onClose,
}) => {
  const { meetingRole, setActiveElement } = useSiteContext();
  const { explicitBoleanCheck } = useEditCtaContext();

  return (
    <div
    className={`relative ${
        !inmeeting
          ? "h-auto"
          : ["top", "bottom"].includes(position)
          ? "h-[150px]"
          : "!h-[89vh] mt-[5%]"
      } w-full flex flex-row mx-auto items-center px-4 md:px-8 py-3 md:py-4 overflow-hidden`}
      style={{ backgroundColor }}
    >
      {/* Close Button */}
      {inmeeting && (
        <button
          className="absolute top-2 right-2 z-20 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors"
          title="Close Banner"
          style={{ right: "8px", top: "8px" }}
          onClick={() => {
            if (meetingRole === "moderator") {
              onClose();
            } else {
              setActiveElement(null);
            }
          }}
        >
          <svg
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}

      {/* Background Image */}
      {(backgroundImage || backgroundImagePreview) && (
        <div
          className="absolute inset-0 w-full h-full opacity-90"
          style={{
            backgroundImage: `url(${
              backgroundImage instanceof File
                ? backgroundImagePreview
                : backgroundImage
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
      )}

      {/* Content Container */}
      <div className="relative z-10 flex items-center justify-between w-full max-w-7xl mx-auto gap-4 md:gap-8">
        {/* Left: Logo */}
        {(logoImage || logoImagePreview) && (
          <div className="flex-shrink-0">
            <img
              src={
                logoImage instanceof File
                  ? logoImagePreview
                  : logoImage || "/yourLogo.svg"
              }
              alt="logo"
              className="w-16 h-16 md:w-20 md:h-20 object-contain"
            />
          </div>
        )}

        {/* Center: Title */}
        <div className="flex-1">
          <h1
            className={`${titleUppercase ? "uppercase" : ""} ${
              explicitBoleanCheck(titleIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(titleIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(titleIsUnderline) ? "underline" : ""
            }`}
            style={{
              color: titleColor,
              fontSize: `${titleFontSize}px`,
              fontFamily: titleFont,
              textAlign: titleTextAlign,
              lineHeight: "1.2",
              whiteSpace: "pre-line",
            }}
          >
            {titleText}
          </h1>
        </div>

        {/* Right: Subtitle and Button */}
        <div className="flex-shrink-0 flex items-center gap-3">
          <div
            className={`text-right ${
              explicitBoleanCheck(subtitleIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(subtitleIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(subtitleIsUnderline) ? "underline" : ""
            }`}
            style={{
              color: subtitleColor,
              fontSize: `${subtitleFontSize}px`,
              fontFamily: subtitleFont,
              textAlign: subtitleTextAlign,
              whiteSpace: "pre-line",
            }}
          >
            {subtitleText}
          </div>

          <button
            className={`px-6 py-2 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl ${
              buttonLink ? "cursor-pointer" : "cursor-default"
            }`}
            style={{
              backgroundColor: buttonBackgroundColor,
              color: buttonFontColor,
              fontSize: `${buttonFontSize}px`,
              fontFamily: buttonFont,
              fontWeight: explicitBoleanCheck(buttonIsBold) ? "bold" : "normal",
              fontStyle: explicitBoleanCheck(buttonIsItalic)
                ? "italic"
                : "normal",
              textDecoration: explicitBoleanCheck(buttonIsUnderline)
                ? "underline"
                : "none",
            }}
            onClick={() => {
              if (buttonLink) {
                window.open(buttonLink, "_blank");
              }
            }}
          >
            {buttonLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HorizontalTemplateOneOneSix;

